
import React from 'react';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';

export const CardTotalFacturacion = () => {

    const {
        total_cliente,
        total_facturado,
        total_por_facturar,
        separacion_miles,
        separacion_decimales, simbolo
    } = useSelector(state => state.ppto.detail)

    return (
        <div className="col d-flex p-2 justify-content-between mt-1 ms-1 p-card-facturacion">
            <div className='d-flex flex-column justify-content-center text-end'>
                <span className='d-flex align-items-center'>
                    <label className='tabla-punto-cliente-d'></label>
                    <span className='ms-1'>
                        <span>Facturado</span>
                        <span className='ms-1'>
                            (<NumberFormat
                                value={total_facturado ? (parseFloat(total_facturado) / parseFloat(total_cliente) * 100) : 0}
                                displayType={'text'}
                                thousandSeparator={','}
                                decimalSeparator={'.'}
                                suffix='%'
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />)
                        </span>
                    </span>
                </span>
                <span style={{ fontSize: '16px' }}>
                    <NumberFormat
                        value={total_facturado}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </span>
            </div>
            <div className='d-flex flex-column justify-content-end text-end'>
                <span className='d-flex align-items-center'>
                    <label className='tabla-punto-cliente-d'></label>
                    <span className='ms-1'>
                        <span>Por facturar</span>
                        <span className='ms-1'>
                            (<NumberFormat
                                value={total_por_facturar ? (parseFloat(total_por_facturar) / parseFloat(total_cliente) * 100) : 0}
                                displayType={'text'}
                                thousandSeparator={','}
                                decimalSeparator={'.'}
                                suffix='%'
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />)
                        </span>
                    </span>
                </span>
                <span style={{ fontSize: '16px' }}>
                    <NumberFormat
                        value={total_por_facturar}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </span>
            </div>
        </div>
    )
}
